import {t} from 'i18next';
import {FoodSection} from '../types/FoodSection';

const allergensOverrides: Record<number, string> = {
    12: '1,2,4,6,8',
    13: '1,2,4,6,8',
    26: '1,2,4,6,8',
    28: '1,2,4,6,8',
    29: '1,2,4,6,8',
};

const getFoodSection = (title: string,
                        foodCount: number,
                        price: number,
                        foodTranslatePrefix: string,
                        minWeight: number | undefined = undefined,
                        startQueueNumber: number,
                        allergens: string): FoodSection => {
    const section: FoodSection = {
        title: title,
        minWeight: minWeight,
        foods: [],
        startQueueNumber: startQueueNumber
    };

    for (let i = 1; i <= foodCount; i++) {
        section.foods.push({
            name: t(`${foodTranslatePrefix}${i}`),
            price: price,
            description: t(`${foodTranslatePrefix}${i}Description`),
            allergens: allergensOverrides[startQueueNumber + i - 1] != null ? allergensOverrides[startQueueNumber + i - 1] : allergens
        });
    }

    return section;
};

const getBaguettes = (): FoodSection => getFoodSection(t('Baguettes'), 15, 3.80, 'Bageta', 130, 1, '1,4,6,8');

const getBakedInFood = (): FoodSection => getFoodSection(t('BakedIn'), 16, 3.80, 'Zapekac', 110, 16, '1,4,6,8');

const getHamburgers = (): FoodSection => getFoodSection(t('Hamburger'), 2, 3.50, 'Hamburger', undefined, 32, '1,3,4,5,6,7,8');

const getHotDogs = (): FoodSection => {
    return {
        title: t('HotDog'),
        foods: [
            {
                name: t(`HotDog1`),
                price: 2.05,
                description: t(`HotDog1Description`),
                allergens: '1,3,4,6,7,8'
            },
            {
                name: t(`HotDog2`),
                price: 2.90,
                description: t(`HotDog2Description`),
                allergens: '1,3,4,6,7,8'
            },
            {
                name: t(`HotDog3`),
                price: 2.60,
                description: t(`HotDog3Description`),
                allergens: '1,3,4,6,7,8'
            }],
        startQueueNumber: 34
    };
};

const getDressings = (): FoodSection => ({
    title: t('Dressing'),
    foods: [
        {
            name: t(`Dressing1`),
            price: 1
        },
        {
            name: t(`Dressing2`),
            price: 0.5
        }]
});

const getDrinks = (): FoodSection => {
    return {
        title: t('Drinks'),
        foods: [
            {
                name: t(`Drink1`),
                price: 2
            },
            {
                name: t(`Drink2`),
                price: 1.65
            },
            {
                name: t(`Drink3`),
                price: 1.65
            },
            {
                name: t(`Drink4`),
                price: 2
            },
            {
                name: t(`Drink5`),
                price: 1.65
            },
            {
                name: t(`Drink6`),
                price: 1.55
            },
            {
                name: t(`Drink7`),
                price: 0.15
            }
        ]
    };
};

export const getFoodSections = (): FoodSection[] => {
    return [
        getBaguettes(),
        getBakedInFood(),
        getHamburgers(),
        getHotDogs(),
        getDrinks(),
        getDressings()
    ];
};